import React from 'react';

function Logo(props) {
  return (
    <svg viewBox="0 0 23 38" {...props}>
      <path
        d="M0 31.184c0 .263.133.5.348.628l10.317 6.092a.653.653 0 00.348.093c.125 0 .24-.034.349-.093a.723.723 0 00.348-.628V26.339l9.255 5.464a.653.653 0 00.349.094.71.71 0 00.348-.094.723.723 0 00.348-.628V6.815a.744.744 0 00-.348-.627L11.37.095a.698.698 0 00-.705 0 .723.723 0 00-.348.628V11.66L1.062 6.196a.698.698 0 00-.705 0 .723.723 0 00-.349.628L0 31.184zM2.115 19l8.202-4.845v9.69L2.115 19zm17.805 0l-8.202 4.845v-9.69L19.92 19zm.705-10.937v9.69l-8.202-4.845 8.202-4.845zM1.41 29.937v-9.69l8.202 4.845-8.202 4.845zm0-21.874l8.202 4.845-8.202 4.844v-9.69zM11.727 1.97l8.202 4.844-8.202 4.845V1.97zm8.898 27.966l-8.202-4.845 8.202-4.845v9.69zm-10.308 6.092l-8.202-4.845 8.202-4.845v9.69z"
        fill="var(--fill)"
      />
    </svg>
  );
}

export default Logo;
